import React from 'react';
import { useSelector } from 'react-redux';
import { StoreInterface } from '../../store/types';
import DE from './privacy-policy/DE';
import GB from './privacy-policy/GB';
import LegalPage from './resolveLegalPageComponent';
import useLegalDocument from './useLegalDocument';

export default function PrivacyPolicy() {
  const { company } = useSelector((store: StoreInterface) => store.initialData);

  const { generated, isPending } = useLegalDocument('privacy-policy');

  return (
    <LegalPage
      bundles={{ de: DE, gb: GB }}
      legalPack={company?.region?.legal_pack}
      generated={generated}
      isPending={isPending}
    />
  );
}
